import makeRequest from './makeRequest';
export default makeRequest;
